/**
 * This file contains the messages used across the application.
 * Grouping them in a single file makes it easier to manage and update them.
 **/

/**
 * IMPORTANT
 * All translations should be done in the component.
 * Otherwise, the translation will not work.
 **/
const editPhaseInfoMessage =
    'The status and current product cannot be modified while the phase is in progress.';
const noSensorConnectedMessage = 'No sensors are connected to this asset.';
const noDataAvailableMessage = 'No data available for this asset.';

export {
    editPhaseInfoMessage,
    noSensorConnectedMessage,
    noDataAvailableMessage
};
